import { Spinner } from '@agro-club/agroclub-shared'
import styled from 'styled-components'

export const SpinnerCenter = styled(Spinner)`
  position: absolute;
  top: 50%;
  right: 50%;
`
